/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { PageView, Event } from "../GoogleAnalytics";
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Snackbar from '@mui/material/Snackbar';
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import alerttypemessagingService from '../../services/alerttypemessaging.service';
import Loader from "../Loader/Loader";
import {AssetTypeDict} from "../../componentObjects";

function CustomizeAlerts(props) {
    
    const { classes, isLoading, currentPartnerId, _isMounted, setActivePath, showUnsavedModal, onContinueFromComponent } = props;
    const [isMounted, setIsMounted] = useState(false);
    const [loading, setLoading] = useState(true);
    const [typeValidated, setTypeValidated] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [alertMessaging, setAlertMessaging] = useState([]);
    const [customMessaging, setCustomMessaging] = useState({});
    const [isCustom, setIsCustom] = useState(false);
    const [showUnsaved, setShowUnsaved] = useState(null);
    const [showSaveConfirm, setShowSaveConfirm] = useState(false);
    const [showRestoreConfirm, setShowRestoreConfirm] = useState(false);
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [statusMessage, setStatusMessage] = useState("");
    const [proNotification, setProNotification] = useState([]);

    function getStorageValue(key, defaultValue, isJson) {
        const saved = localStorage.getItem(key);
        var value = saved !== null ? saved : defaultValue;
        if (isJson && value !== defaultValue && value !== "") {
            try {
                value = JSON.parse(value);
            }
            catch(e) {
                console.log(e);
                console.log(`error parsing value: ${value}`);
            }
        }
        return value;
    }
    
    function getAlphabeticAlerts(response) {
        let alertMsging = response;
        if (response !== null && response !== undefined && response.length) {
            alertMsging = response.sort((a, b) => {
                const nameA = a.typeName;
                const nameB = b.typeName;

                return nameA.localeCompare(nameB);
            });
        }
        return alertMsging;
    }

    const populateInfo = (partnerId, unsaved) => {
        setLoading(true);
/*        if (_isMounted && isMounted) {*/
            PageView();
            if (!unsaved) {
                alerttypemessagingService.getpartnermessaging(partnerId)
                .then(response => {
                    /*if (_isMounted && isMounted) {*/
                        let alertMsging = getAlphabeticAlerts(response);
                        setAlertMessaging(alertMsging);
                        setSelectedIndex(0);
                        setCustomMessaging(response[selectedIndex]);
                        const isCustom = response[selectedIndex].isCustom === true;
                        setIsCustom(isCustom);
                        localStorage.setItem('alertMessaging', JSON.stringify(response));
                        //set local storage?
                        updateLocalStorage(unsaved,customMessaging);
                        setLoading(false);
                    /*}*/
                })
                .catch(e => {
                    console.log(e);
                })
            }
            else {
                const alertMessaging = getStorageValue('alertMessaging', '[]', true);
                const customIndex = parseInt(getStorageValue('customIndex', 0));
                const customMessaging = getStorageValue('customMessaging', '{}', true);
                let alertMsging = getAlphabeticAlerts(alertMessaging);
                setAlertMessaging(alertMsging);
                setSelectedIndex(customIndex);
                setCustomMessaging(customMessaging);
                const isCustom = alertMessaging[selectedIndex]?.isCustom === true;
                setIsCustom(isCustom);
                setLoading(false);
            }
     /*   }*/
    }

    useEffect(() => {
       /* const abortController = new AbortController();
        setIsMounted(true);*/
        PageView();

        if (!isLoading) {
            let unsaved = getStorageValue('unsavedChanges', false);
            unsaved = unsaved === 'true' || unsaved === true ? true : false;
            populateInfo(currentPartnerId, unsaved);
        }

       /* return () => {
            setIsMounted(false);        
        };*/
    }, [currentPartnerId, isLoading]);

    useEffect(() => {
        if (showSnackbar) {
            const timer = setTimeout(() => {
                setShowSnackbar(false);
                setStatusMessage("");
            }, 6000); 

            return () => clearTimeout(timer); 
        }
    }, [showSnackbar]);

    const updateLocalStorage = (unsavedChanges, data, index = null) => {
        localStorage.setItem('unsavedChanges', unsavedChanges);
        localStorage.setItem('customMessaging', JSON.stringify(data));
        localStorage.setItem('customIndex', index == null ? selectedIndex : index);
       /* if (isMounted) {*/
            setShowSnackbar(false);
       /* }*/
    }

    // inputs
    const onSelectAlertType = (e) => {
        const typeIndex = e.target.value;
        const newType = alertMessaging[typeIndex];
        setSelectedIndex(typeIndex);
        const customData = { ...customMessaging, 
            id: newType.id,
            typeName: newType.typeName,
            alertMessage: newType.alertMessage,
            severity: newType.severity,
            possibleCauses: newType.possibleCauses,
            risk: newType.risk,
            techAction: newType.techAction,
            homeownerAction: newType.homeownerAction,
            assetTypeId: newType.assetTypeId,
            notificationTime: newType.notificationTime,
            isCustom: newType.isCustom
        };
        updateLocalStorage(false, customData, typeIndex);
        setCustomMessaging(customData);
        const typeCustom = customData?.isCustom === true;
        setIsCustom(typeCustom);
    }

    const onChangeMessage = (e) => {
        const customData = { ...customMessaging, alertMessage: e.target.value };
        updateLocalStorage(true, customData);
        setCustomMessaging(customData);
    }

    const onChangeSeverity = (e) => {
        const customData = { ...customMessaging, severity: e.target.value };
        updateLocalStorage(true, customData);
        setCustomMessaging(customData);
    }
    const onChangeNotificationTime = (e) => {
        const customData = { ...customMessaging, notificationTime: e.target.value };
        updateLocalStorage(true, customData);
        setCustomMessaging(customData);
    }
    

    const onChangePossibleCauses = (e) => {
        const customData = { ...customMessaging, possibleCauses: e.target.value };
        updateLocalStorage(true, customData);
        setCustomMessaging(customData);
    }

    const onChangeRisk = (e) => {
        const customData = { ...customMessaging, risk: e.target.value };
        updateLocalStorage(true, customData);
        setCustomMessaging(customData);
    }

    const onChangeTechAction = (e) => {
        const customData = { ...customMessaging, techAction: e.target.value };
        updateLocalStorage(true, customData);
        setCustomMessaging(customData);
    }

    const onChangeHomeownerAction = (e) => {
        const customData = { ...customMessaging, homeownerAction: e.target.value };
        updateLocalStorage(true, customData);
        setCustomMessaging(customData);
    }
    
    //restore and save

    const restoreMessaging = async () => {
        setLoading(true);
        const response = await alerttypemessagingService.restore(parseInt(currentPartnerId), customMessaging.id, customMessaging.assetTypeId);
        if (response !== null && response !== undefined) {
            const customData = response;
            let newMessaging = [...alertMessaging];
            newMessaging[selectedIndex] = customData;
            alertMessaging[selectedIndex] = customData;
            let alertMsging = getAlphabeticAlerts(newMessaging);
            setAlertMessaging(alertMsging);
            setCustomMessaging(customData);
            setIsCustom(false);
            setShowRestoreConfirm(false);
            updateLocalStorage(false, customData);
            setLoading(false);
        }
    }

    const handleRestore = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        setShowRestoreConfirm(true);
    }

    const updateMessaging = async (goNextPage) => {
        const response = await alerttypemessagingService.setpartnermessaging(parseInt(currentPartnerId), customMessaging);
        if (response != null && response != undefined && response != false) {
            setStatusMessage("Successfully updated partner alert messaging");
            let newMessaging = [...alertMessaging];
            newMessaging[selectedIndex] = customMessaging;
            alertMessaging[selectedIndex] = customMessaging;
            setAlertMessaging(newMessaging);
            setIsCustom(true);
            updateLocalStorage(false, customMessaging);
        }
        else {
            setStatusMessage("Failed to update partner alert messaging.");
        }
        setTypeValidated(false);
        setLoading(false);
        setShowSnackbar(true);
        if (goNextPage)
            onContinueWithoutSaving();
    }

    const updateType = () => {
        setLoading(true);
        updateMessaging(false);
        setShowSaveConfirm(false);
    }

    const onSaveType = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
            event.stopPropagation();
        if (form.checkValidity() === false) {
            setTypeValidated(false);
        }
        else {
            setTypeValidated(true);
            setLoading(true);
            setShowSaveConfirm(true);
        }
    }

    const onSaveThenContinue = e => {
        localStorage.setItem("showUnsavedModal", false);
        setLoading(true);
        setShowUnsaved(false);
        const customData = getStorageValue("customMessaging", '{}', true);
        const customIndex = parseInt(getStorageValue('customIndex', 0));
        setCustomMessaging(customData);
        setSelectedIndex(customIndex);
        //validate first
        updateMessaging(true);
    }

    const onContinueWithoutSaving = e => {
        localStorage.setItem("showUnsavedModal", false);
        updateLocalStorage(false, {}, 0);
        onContinueFromComponent(continueCallback);
    }

    const continueCallback = () => {
        const nextPath = getStorageValue('nextPath', "/customizeAlerts");
        props.history.push(nextPath);
        setActivePath(nextPath);
    }

    const setShowModal = (e) => {
        setShowSaveConfirm(!showSaveConfirm);
    }

    const setShowRestoreModal = (e) => {
        setShowRestoreConfirm(!setShowRestoreConfirm);
    }

    let contents = loading 
    ? <Loader />
    : <div>
        <div className={"form-wrapper"}>
            <Form noValidate validated={typeValidated} onSubmit={onSaveType}>
                <Row className={"border-bottom"}>
                    <Form.Group as={Col} md="4" controlId="assetType">
                        <Form.Label>Pro Notifications time</Form.Label>
                        <Form.Control required as="select" value={customMessaging.notificationTime} onChange={onChangeNotificationTime} isInvalid={(typeValidated && customMessaging.alertTypeId == 0) ? true : false}>
                            <option value={"0"} defaultValue >Select notification time</option>
                            <option value={"24"}>24hr after pro</option>
                            <option value={"48"}>48hr after pro</option>
                        </Form.Control>
                    </Form.Group>
                </Row>
                <Row className={"border-bottom"}>
                    <Form.Group as={Col} md="4" offset="4" controlId="alertType2">
                        <Form.Label>Alert Type</Form.Label>
                        <Form.Control as="select" value={selectedIndex} onChange={onSelectAlertType}>
                            <option value={-1} disabled defaultValue hidden>Select Alert Type...</option>
                            {alertMessaging.map((type, index) => 
                                <option key={`alertType=${index}-2`} value={index}>{type.typeName}</option>
                            )}
                        </Form.Control>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="assetType">
                        <Form.Label>Asset Type</Form.Label>
                        <Form.Control className={"disabled-prop"} disabled type="text" placeholder="" value={AssetTypeDict.find(d => d.id === customMessaging.assetTypeId)?.name} />
                    </Form.Group>
                </Row>

                <Row>
                    <Form.Group as={Col} md="6" controlId="alertMessage">
                        <Form.Label>Message</Form.Label>
                        <Form.Control required type="text" placeholder="" value={customMessaging.alertMessage} onChange={onChangeMessage} />
                        <Form.Control.Feedback type="invalid">Alert Message is required</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="3" controlId="severity">
                        <Form.Label>Severity</Form.Label>
                        <Form.Control required as="select" value={customMessaging.severity} onChange={onChangeSeverity} isInvalid={(typeValidated && customMessaging.alertTypeId == 0) ? true : false}>
                            <option value="" disabled defaultValue hidden>Select Severity...</option>
                            <option value={"Critical"}>Critical</option>
                            <option value={"Warning"}>Warning</option>
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">Severity is required</Form.Control.Feedback>
                    </Form.Group>
                </Row>
                <Row>
                    <Form.Group as={Col} md="6" controlId="possibleCauses">
                        <Form.Label>Possible Causes</Form.Label>
                        <Form.Control required type="text" placeholder="" value={customMessaging.possibleCauses} onChange={onChangePossibleCauses} />
                        <Form.Control.Feedback type="invalid">Possible Causes required</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="6" controlId="risk">
                        <Form.Label>Risk</Form.Label>
                        <Form.Control required type="text" placeholder="" value={customMessaging.risk} onChange={onChangeRisk} />
                        <Form.Control.Feedback type="invalid">Risk is required</Form.Control.Feedback>
                    </Form.Group>
                </Row>
                <Row>
                    <Form.Group as={Col} md="6" controlId="techAction">
                        <Form.Label>Technician Action</Form.Label>
                        <Form.Control required type="text" placeholder="" value={customMessaging.techAction} onChange={onChangeTechAction} />
                        <Form.Control.Feedback type="invalid">Technician Action is required</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="6" controlId="homeownerAction">
                        <Form.Label>Homeowner Action</Form.Label>
                        <Form.Control required type="text" placeholder="" value={customMessaging.homeownerAction} onChange={onChangeHomeownerAction} />
                        <Form.Control.Feedback type="invalid">Homeowner Action is required</Form.Control.Feedback>
                    </Form.Group>
                </Row>

                <Button type="submit" className={"form-save-btn"}>Save</Button>
                <Button type="button" onClick={handleRestore} className={"form-btn"} style={{ display: isCustom ? 'unset' : 'none' }}>Restore Default</Button>
            </Form>
        </div>
    </div>;

    return (
        <div sx={(theme)=>({
            [theme.breakpoints.down('md')]: {
                marginLeft: '-225px !important',
            },
        })}>
            <div className='infoPage'>
                <h2 className="pageTitle dashboard-title" id="tabelLabel">Customize Alert Messaging</h2>
                {contents}

                <ConfirmationModal 
                    show={showSaveConfirm} 
                    onYes={updateType} 
                    onClick={setShowModal} 
                    message={"Would you like to save your changes to this alert type's messaging?"} 
                    title={"Save Changes"}></ConfirmationModal>

                <ConfirmationModal 
                    show={showRestoreConfirm} 
                    onYes={restoreMessaging} 
                    onClick={setShowRestoreModal} 
                    message={"Would you like to restore this alert type's messaging to deafult?"} 
                    title={"Restore Default"}></ConfirmationModal>

                <ConfirmationModal 
                    show={showUnsaved == null ? localStorage.getItem('showUnsavedModal') === 'true' : showUnsavedModal} 
                    onYes={onSaveThenContinue} 
                    onClick={onContinueWithoutSaving} 
                    message={"You have unsaved changes, would like to save before leaving?"} 
                    title={"Unsaved Changes"}></ConfirmationModal>

                <Snackbar open={showSnackbar} message={statusMessage} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={6000} />
            </div>
        </div>
    );
}

export default CustomizeAlerts;